import React from "react";
import "./modal-client.scss";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { ReactComponent as Done } from "../../../icons-office/done.svg";

const ChangesSaved = ({ save }) => {
  return (
    <Dialog
      open={save}
      maxWidth={"xl"}
      PaperProps={{
        style: { borderRadius: 15, width: 80, height: 80 },
      }}
    >
      <DialogContent id="changeSavedContent">
        <Done />
      </DialogContent>
    </Dialog>
  );
};

export default ChangesSaved;
